/* Maps an ExpenseLine.lineType (CARD_CHARGE / OUT_OF_POCKET / MILEAGE) to a labelled
   Nomad Badge. Card = neutral, out-of-pocket = blue, mileage = feature-accent (pink),
   matching the approved Report-detail mockup. */
import { Badge, type BadgeProps } from '@andavo/web-ui';
import type { ExpenseLine } from './hooks/use-reports';

const CONFIG: Record<
  ExpenseLine['lineType'],
  { label: string; variant: NonNullable<BadgeProps['variant']> }
> = {
  CARD_CHARGE: { label: 'Card', variant: 'default' },
  OUT_OF_POCKET: { label: 'Out-of-pocket', variant: 'blue' },
  MILEAGE: { label: 'Mileage', variant: 'feature' },
};

export function LineTypeBadge({ type }: { type: ExpenseLine['lineType'] }) {
  const { label, variant } = CONFIG[type];
  return (
    <Badge variant={variant} intent="background" borderRadius="round">
      {label}
    </Badge>
  );
}
